// Generated by purs version 0.15.0
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var ChannelId = function (x) {
    return x;
};
var eqChannelId = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var newtypeChannelId = {
    Coercible0: function () {
        return undefined;
    }
};
var genericChannelId = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showChannelId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericChannelId)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "ChannelId";
        }
    }))
};
var unscrambleDecodeChannelId = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericChannelId)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Unscramble.decodeInt1)))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeChannelId = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericChannelId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ChannelId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))(encodingOpts)
};
var decodeChannelId = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericChannelId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ChannelId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    ChannelId,
    encodingOpts,
    genericChannelId,
    showChannelId,
    eqChannelId,
    decodeChannelId,
    unscrambleDecodeChannelId,
    encodeChannelId,
    newtypeChannelId
};
//# sourceMappingURL=index.js.map
